import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { RootState } from '../store/store';
import { DASHBOARD_URL } from '@src/constants/URLS.const';
import { useCheckAuthResponse, useQueryParams } from '@src/hooks';
import { useEffect, useRef } from 'react';

export function PublicRoute() {
  const { checkAuthResponse } = useCheckAuthResponse();
  const { getQueryParam } = useQueryParams();
  const accessToken = useSelector(
    (state: RootState) => state.user.user?.accessToken
  );

  const ranRef = useRef(false);

  const redirectUrl = getQueryParam('redirect-url');

  useEffect(() => {
    if (!accessToken || ranRef.current) return;

    ranRef.current = true;
    checkAuthResponse(
      { access_token: accessToken, status: 200, data: [] },
      'login'
    );
  }, [accessToken, checkAuthResponse]);

  if (!accessToken) return <Outlet />;

  if (redirectUrl) {
    return <Navigate to={decodeURIComponent(redirectUrl)} replace />;
  }
  return <Navigate to={DASHBOARD_URL} replace />;
}
